import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './components/HomePage';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import WarehouseMonitoring from './components/WarehouseMonitoring';
import IndustrialSafety from './components/IndustrialSafety';
import PricingPage from './components/PricingPage';
import PolicyKitPage from './components/PolicyKitPage';
import PolicyKitThanksPage from './components/PolicyKitThanksPage';
import NotFoundPage from './components/NotFoundPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/warehouse-phone-monitoring" element={<WarehouseMonitoring />} />
        <Route path="/industrial-safety-monitoring" element={<IndustrialSafety />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/shift-distraction-policy-kit" element={<PolicyKitPage />} />
        <Route path="/shift-distraction-policy-kit/thanks" element={<PolicyKitThanksPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Router>
  );
}

export default App;